<template>
    <section>
        <div class="module-container">
            <div class="templates-list">
            <div class="templates-list__header">
                <span>Listagem de templates</span>
                <button class="btn btn-success" @click="createNewTemplate()"><i class="fas fa-plus"></i>   Criar novo template</button>
                <button class="btn btn-outline-primary" @click="createNewTemplate(), getTemplates()" title="Atualizar listagem"><i class="fas fa-sync"></i></button>
            </div>
            <div v-for="template in allTemplates" :key="template.id">
                <div class="templates-list__item" :class="{'selected': selectedTemplate.id === template.id}" @click="selectTemplate(template)">
                    <span class="item-name">{{ template.name }}</span>
                    <span class="item-category">{{ parseCategory(template.category) }}</span>
                    <span 
                        class="status"
                        :class="{
                            'approved': template.status === 'APPROVED',
                            'pending': template.status === 'PENDING',
                            'rejected': template.status === 'REJECTED'
                        }"
                    >
                        {{ parseStatus(template.status) }}
                    </span>
                </div>
            </div>
        </div>
        <div class="template-preview">
            <div v-if="selectedTemplate" class="template-preview__content">
                <div v-if="selectedTemplate.status === 'PENDING'" class="alert alert-warning">
                    <span>Não é possível editar um template que está pendente de aprovação</span>
                </div>
                <div class="template-preview__section">
                    <span>Nome do template: </span>
                    <input 
                        type="text" 
                        placeholder="Digite o nome do template..." 
                        class="form-control" 
                        v-model="selectedTemplate.name" 
                        :disabled="selectedTemplate.status === 'PENDING' || selectedTemplate.status === 'APPROVED'"
                    >
                </div>
                <div class="template-preview__section">
                    <span>Informações</span>
                    <label>Categoria, idioma e status do template</label>
                    <div class="template-info">
                        <select class="form-control" v-model="selectedTemplate.category" :disabled="(selectedTemplate.status === 'PENDING' || selectedTemplate.status === 'APPROVED')">
                            <option value="" selected disabled>Escolha a categoria...</option>
                            <!-- <option value="AUTHENTICATION">Autenticação</option> -->
                            <option value="MARKETING">Marketing</option>
                            <option value="UTILITY">Utilidade</option>
                        </select>
                        <select class="form-control" v-model="selectedTemplate.language" :disabled="(selectedTemplate.status === 'PENDING' || selectedTemplate.status === 'APPROVED')">
                            <option value="" selected disabled>Escolha o idioma...</option>
                            <option value="pt_BR">Português (Brasil)</option>
                            <option value="en_US">Inglês (EUA)</option>
                        </select>
                        <div class="status">
                            <span>Status: </span>
                            <span 
                            :class="{
                                'approved': selectedTemplate.status === 'APPROVED',
                                'pending': selectedTemplate.status === 'PENDING',
                                'rejected': selectedTemplate.status === 'REJECTED'
                            }"
                            >{{ parseStatus(selectedTemplate.status) }}</span>
                        </div>
                        <div class="alert alert-danger" v-if="rejectionReason">
                            <span>Motivo da rejeição: {{ rejectionReason }}</span>
                        </div>
                    </div>
                </div>
                <div class="template-preview__section">
                    <span>Cabeçalho (Opcional)</span>
                    <label>Adicione um título ou escolha qual tipo de mídia você usará para esse cabeçalho</label>
                    <div class="template-header">
                        <select class="form-control" v-model="templateHeader.format" :disabled="(selectedTemplate.status === 'PENDING')">
                            <option value="" selected>Nenhum</option>
                            <option value="TEXT">Texto</option>
                            <!-- <option value="IMAGE">Imagem</option>
                            <option value="VIDEO">Vídeo</option> -->
                        </select>
                        <input v-if="templateHeader.format === 'TEXT'" class="form-control" v-model="templateHeader.text" :disabled="(selectedTemplate.status === 'PENDING')" />
                        <!-- <input v-if="templateHeader.format === 'IMAGE'" type="file" id="fileInput" accept="image/jpeg, image/png" style="display: none;" @change="onFileSelected" :disabled="(selectedTemplate.status === 'PENDING')" />
                        <input v-if="templateHeader.format === 'VIDEO'" type="file" id="fileInput" accept="video/mp4" style="display: none;" @change="onFileSelected" :disabled="(selectedTemplate.status === 'PENDING')" />
                        <label v-if="templateHeader.format === 'IMAGE' || templateHeader.format === 'VIDEO'" for="fileInput" class="custom-file-upload" :class="{'file-exist': headerMedia}">
                            <span v-if="headerMedia">
                                Alterar arquivo...
                            </span>
                            <span v-else>
                                Adicionar arquivo...
                            </span>
                        </label> -->
                    </div>
                </div>
                <div class="template-preview__section">
                    <span>Corpo</span>
                    <label>Insira o texto da sua mensagem no idioma selecionado</label>
                    <custom-editor 
                        @updatedVariable="updatedVariables => variables = updatedVariables" 
                        @writing="writingText" 
                        :removeVariable="removedVariable" 
                        :templateVariables="templateVariables"
                        :bodyText="templateBody.text" 
                        :selectingTemplate="selectedTemplateCheck"
                        :disabled="(selectedTemplate.status === 'PENDING')"
                        :refreshingTemplate="refreshTemplate"
                    />
                </div>
                <div v-if="variables.filter(el => el.id !== null).length" class="template-preview__section">
                    <span>Variáveis</span>
                    <label>Parâmetros a serem enviados no corpo do template</label>
                    <div v-for="variable in variables.filter(el => el.id !== null)" :key="variable.id" class="variables-container">
                        <div v-if="variable.id"  class="variable-item">
                            <span>{{ variable.id }}</span>
                            <input class="form-control" v-model="variable.text" :disabled="(selectedTemplate.status === 'PENDING')" />
                            <button class="btn btn-danger" @click="removeVariable(variable.id)" :disabled="(selectedTemplate.status === 'PENDING')">Remover</button>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="selectedTemplate.existing" class="action-buttons">
                    <button class="btn btn-danger" @click="deleteTemplate" :disabled="(selectedTemplate.status === 'PENDING')"><i class="fas fa-trash"></i>   Excluir</button>
                    <button 
                        class="btn btn-primary" 
                        @click="editTemplate" 
                        :disabled="selectedTemplate.status === 'PENDING'"
                    >
                        <i class="fas fa-save"></i>   Salvar
                    </button>
                </div>
                <div v-else class="action-buttons">
                    <button class="btn btn-danger"  @click="createNewTemplate"><i class="fas fa-times"></i>   Limpar</button>
                    <button 
                        class="btn btn-primary" 
                        @click="createTemplate"
                        :disabled="selectedTemplate.status === 'PENDING'"
                    >
                        
                        <i class="fas fa-plus"></i>   Criar
                    </button>
                </div>
            </div>
        </div>
        <div class="template-message-preview">
            <div class="template-message-preview__header">
                <span>Preview do template</span>
            </div>
            <div class="preview-slot">
                <div v-if="(templateHeader.format === 'TEXT' && templateHeader.text !== '') || (templateHeader.format === 'IMAGE' && uploadedFile) || (templateHeader.format === 'VIDEO' && uploadedFile) || (bodyText.trim() !== '')" class="message-item">
                    <div v-if="templateHeader.text" class="message-header">
                        <span>{{ templateHeader.text }}</span>
                    </div>
                    <!-- <div v-else class="message-header">
                        <img v-if="templateHeader.format === 'IMAGE'" :src="headerMedia" alt="Preview" class="w-100"/>
                        <video v-else-if="templateHeader.format === 'VIDEO'" :src="headerMedia" controls class="w-100"></video>
                    </div> -->
                    <div class="message-body">
                        <span class="body-preview-text" v-html="bodyText"></span>
                    </div>
                </div>
                <div v-else class="alert alert-warning m-2">
                    <span>Selecione um template para visualizar, ou crie seu template</span>
                </div>
            </div>
        </div>
        </div>
        <div class="modal fade" tabindex="-1" role="dialog" id="loading-modal" data-backdrop="static" data-keyboard="false" :class="{'modal-showing': loading}">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <b-spinner small variant="primary"/>
                        <span>Carregando. Por favor, aguarde...</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Swal from 'sweetalert2';

    export default {
        name: 'Templates',
        components: {},
        data() {
            return {
                customToolbar: [["bold", "italic"]],
                allTemplates: [],
                selectedTemplate: {
                    id: null,
                    existing: false,
                    new: false,
                    name: '',
                    category: '',
                    language: '',
                    status: '',
                    components: []
                },
                templateHeader: {
                    type: 'HEADER',
                    format: '',
                    text: '',
                    media: '',
                    example: {}
                },
                templateBody: {
                    type: 'BODY',
                    text: '',
                    media: '',
                    example: {}
                },
                bodyText: '',
                variables: [],
                templateVariables: [],
                removedVariable: null,
                oldText: '',
                oldRawText: '',
                selectedTemplateCheck: false,
                refreshTemplate: false,
                uploadedFile: null,
                uploadedFileId: '',
                loading: false,
                rejectionReason: '',
                headerMedia: null
            }
        },
        async mounted(){
            await this.getTemplates()
        },
        methods: {
            validateForm(){
                if(!this.selectedTemplate.name){
                    Swal.fire({
                        title: 'Erro ao criar template',
                        text: 'O nome do template não pode estar vazio',
                        type: "error",
                        showConfirmButton: true
                    });
                    return false;
                }
                if(this.bodyText.trim() === ''){
                    Swal.fire({
                        title: 'Erro ao criar template',
                        text: 'O corpo do template não pode estar vazio',
                        type: "error",
                        showConfirmButton: true
                    });
                    return false;
                }
                if(this.templateHeader.format === 'TEXT' && !this.templateHeader.text){
                    Swal.fire({
                        title: 'Erro ao criar template',
                        text: 'O cabeçalho do template não pode estar vazio',
                        type: "error",
                        showConfirmButton: true
                    });
                    return false;
                }
                if(!this.selectedTemplate.category){
                    Swal.fire({
                        title: 'Erro ao criar template',
                        text: 'É obrigatório selecionar a categoria do template',
                        type: "error",
                        showConfirmButton: true
                    })
                    return false;
                }
                if(!this.selectedTemplate.language){
                    Swal.fire({
                        title: 'Erro ao criar template',
                        text: 'É obrigatório selecionar o idioma do template',
                        type: "error",
                        showConfirmButton: true
                    })
                    return false;
                }

                return true;
            },
            createObjectURL(file) {
                return URL.createObjectURL(file);
            },
            async getTemplates(){
                axios.get(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_template_list`).then(({data}) => {
                    if(data){
                        this.allTemplates = data;
                    }
                });
            },
            selectTemplate(template){
                this.getTemplateInfo(template.id);
                this.selectedTemplate = template;
                this.selectingTemplate();
                this.bodyText = ''
                this.uploadedFile = null;
                this.uploadedFileId = '';
                this.headerMedia = null
                this.templateHeader = {
                    type: 'HEADER',
                    format: '',
                    text: '',
                    example: {}
                }
                this.templateBody = {
                    type: 'BODY',
                    text: '',
                    media: '',
                    example: {}
                }
                this.$set(this.templateBody, 'text', '');
                template.components.forEach((component) => {
                    switch(component.type){
                        case 'HEADER':
                            this.templateHeader = component;
                            break;
                        case 'BODY':
                            this.templateBody = component;
                            break;
                        default:
                            break;
                    }
                });
                this.selectedTemplate.existing = true;
                this.selectedTemplate.new = false;
                this.getTemplateVariables()
                // this.getHeaderMedia()
            },
            selectingTemplate(){
                this.selectedTemplateCheck = true;

                setTimeout(() => {
                    this.selectedTemplateCheck = false;
                }, 50);
            },
            refreshingTemplate(){
                this.refreshTemplate = true;

                setTimeout(() => {
                    this.refreshTemplate = false;
                }, 0);
            },
            createNewTemplate(){
                console.log('creating')
                this.rejectionReason = '';
                this.templateVariables = [];
                this.refreshingTemplate();
                this.bodyText = '';
                this.oldText = '';
                this.oldRawText = '';
                this.uploadedFile = null;
                this.uploadedFileId = '';
                this.headerMedia = null;
                this.selectedTemplate = {
                    id: null,
                    existing: false,
                    new: true,
                    name: '',
                    category: '',
                    language: '',
                    status: '',
                    components: []
                }

                this.templateHeader = {
                    type: 'HEADER',
                    format: '',
                    text: '',
                    media: '',
                    example: {}
                }
                this.templateBody = {
                    type: 'BODY',
                    text: '',
                    media: '',
                    example: {}
                }
            },
            getTemplateVariables(refreshing = false){
                this.templateVariables = [];
                const bodyVariables = this.templateBody.example
                if(!bodyVariables) return this.bodyText = this.templateBody.text;
                if(Object.keys(bodyVariables).length){
                    if(bodyVariables.body_text.length){
                        bodyVariables.body_text[0].forEach((text, index) => {
                            this.templateVariables.push({id: this.parseVariable(index + 1), text: text});
                            if(refreshing){
                                this.bodyText = this.templateBody.text.replace(this.parseIndex(this.parseVariable(index + 1)), text);
                            } else {
                                this.bodyText = this.bodyText.replace(this.parseVariable(index + 1), text);
                            }
                        });
                    }
                }
            },
            removeVariable(variableId){
                this.removedVariable = variableId;

                setTimeout(() => {
                    this.removedVariable = null;
                }, 50);
            },
            parseVariable(index){
                if(index === 1) return '1️⃣';
                if(index === 2) return '2️⃣';
                if(index === 3) return '3️⃣';
                if(index === 4) return '4️⃣';
                if(index === 5) return '5️⃣';
                if(index === 6) return '6️⃣';
                if(index === 7) return '7️⃣';
                if(index === 8) return '8️⃣';
                if(index === 9) return '9️⃣';
                if(index === 10) return '🔟';
            },
            parseIndex(variableId){
                if(variableId === '1️⃣') return  '{{1}}';
                if(variableId === '2️⃣') return  '{{2}}';
                if(variableId === '3️⃣') return  '{{3}}';
                if(variableId === '4️⃣') return  '{{4}}';
                if(variableId === '5️⃣') return  '{{5}}';
                if(variableId === '6️⃣') return  '{{6}}';
                if(variableId === '7️⃣') return  '{{7}}';
                if(variableId === '8️⃣') return  '{{8}}';
                if(variableId === '9️⃣') return  '{{9}}';
                if(variableId === '🔟') return  '{{10}}';
            },
            parseStatus(status){
                switch(status){
                    case 'APPROVED':
                        return '🟢 Aprovado';
                    case 'PENDING':
                        return '🟠 Pendente';
                    case 'REJECTED':
                        return '🔴 Rejeitado';
                    default:
                        return 'Sem status definido';
                }
            },
            parseCategory(category){
                switch(category){
                    case 'AUTHENTICATION':
                        return '🔐 Autenticação';
                    case 'MARKETING':
                        return '📈 Marketing';
                    case 'UTILITY':
                        return '🔧 Utilidade';
                    default:
                        return 'Sem categoria definida';
                }
            },
            writingText(value){
                this.oldText = value.html;
                this.oldRawText = value.text;
                if(this.variables.length){
                    this.variables.map(el => {
                        if(el.id && el.text !== ''){
                            value.html = value.html.replace(el.id, el.text);
                        }
                    });
                }
                this.bodyText = value.html;
            },
            onFileSelected(event) {
                const maxFileSize = 10 * 1024 * 1024; // 5 MB em bytes
                const file = event.target.files[0];

                if (file.size > maxFileSize) {
                    Swal.fire({
                        title: 'Erro ao selecionar arquivo',
                        text: 'O arquivo selecionado excede o tamanho máximo permitido de 10 MB.',
                        type: "error",
                        showConfirmButton: true
                    });

                    return;
                }

                this.uploadedFile = file;
                // this.getHeaderMedia();
            },
            async createTemplate(){
                if(!this.validateForm()) return;
                Swal.fire({
                    title: 'Criação de template',
                    text: 'Seu template estará sujeito a aprovação da plataforma Meta. Esta aprovação poderá demorar até 48 horas. Deseja continuar?',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Cancelar',
                    type: "warning",
                    showCloseButton: true
                }).then(async result => {
                    if(result.value) {
                        this.loading = true
                        let bodyObj = {
                            type: 'BODY',
                            text: this.oldText.replace(/\n$/, '').replace(/(🔟|9️⃣|8️⃣|7️⃣|6️⃣|5️⃣|4️⃣|3️⃣|2️⃣|1️⃣)/g, this.parseIndex),
                        }

                        bodyObj.text = bodyObj.text
                            .replace(/<p>/g, '')
                            .replace(/<\/p>/g, '')
                            .replace(/<br\/>/g, "\n");
                        let templateName = this.selectedTemplate.name.toLowerCase();
                        templateName = templateName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                        templateName = templateName.replace(/\s+/g, "_");
                        templateName = templateName.replace(/[^a-z0-9_]/g, "");
                        if(this.variables.length){
                            bodyObj.example = {
                                body_text: [
                                    this.variables.map(el => el.text)
                                ]
                            }
                        }
                        let template = {
                            name: templateName,
                            language: this.selectedTemplate.language,
                            category: this.selectedTemplate.category,
                            content: []
                        }
                        if(this.templateHeader.format === 'TEXT'){
                            template.content.push({
                                type: 'HEADER',
                                format: 'TEXT',
                                text: this.templateHeader.text
                            })
                        }
                        // if(this.templateHeader.format === 'IMAGE' || this.templateHeader.format === 'VIDEO'){
                        //     const fileId = await  this.uploadHeaderFile();
                        //     if(fileId){
                        //         template.content.push({
                        //             type: 'HEADER',
                        //             format: this.templateHeader.format,
                        //             example: {
                        //                 header_handle: [ fileId ]
                        //             }
                        //         })
                        //     }
                        // }
                        template.content.push(bodyObj)
                        axios.post(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/create_template`, template).then(async ({data}) => {
                            if(!data.status || data.status !== 'error'){
                                Swal.fire({
                                    title: 'Template criado com sucesso!',
                                    type: "success",
                                    toast: true,
                                    timer: 3000,
                                    showConfirmButton: false,
                                    position: 'top-end'
                                });

                                // await this.saveLocalFile(data.id)

                                this.getTemplates();
                                this.createNewTemplate();
                                this.loading = false
                            } else {
                                this.loading = false
                                Swal.fire({
                                    title: 'Erro ao criar template',
                                    html: data.error.error.error_user_msg ? data.error.error.error_user_msg : data.error.error.message,
                                    type: "error",
                                    showConfirmButton: true
                                });
                            }
                        })
                    }
                });
            },
            async editTemplate(){
                if(!this.validateForm()) return;
                Swal.fire({
                    title: 'Edição de template',
                    text: 'Seu template estará sujeito a aprovação da plataforma Meta. Esta aprovação poderá demorar até 48 horas. Deseja continuar?',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Cancelar',
                    type: "warning",
                    showCloseButton: true
                }).then(async result => {
                    if(result.value) {
                        this.loading = true
                        let bodyObj = {
                            type: 'BODY',
                            text: this.oldText.replace(/\n$/, '').replace(/(🔟|9️⃣|8️⃣|7️⃣|6️⃣|5️⃣|4️⃣|3️⃣|2️⃣|1️⃣)/g, this.parseIndex),
                        }

                        bodyObj.text = bodyObj.text
                            .replace(/<p>/g, '')
                            .replace(/<\/p>/g, '')
                            .replace(/<br\/>/g, "\n");

                        if(this.variables.length){
                            bodyObj.example = {
                                body_text: [
                                    this.variables.map(el => el.text)
                                ]
                            }
                        }
                        let template = {
                            template_id: this.selectedTemplate.id,
                            content: []
                        }
                        if(this.templateHeader.format === 'TEXT'){
                            template.content.push({
                                type: 'HEADER',
                                format: 'TEXT',
                                text: this.templateHeader.text
                            })
                        }
                        // if(this.templateHeader.format === 'IMAGE' || this.templateHeader.format === 'VIDEO'){
                        //     const fileId = await this.uploadHeaderFile();
                        //     if(fileId){
                        //         template.content.push({
                        //             type: 'HEADER',
                        //             format: this.templateHeader.format,
                        //             example: {
                        //                 header_handle: [ fileId ]
                        //             }
                        //         })
                        //     }
                        // }
                        template.content.push(bodyObj)
                        axios.put(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/edit_template`, template).then(async ({data}) => {
                            if(!data.status || data.status !== 'error'){
                                Swal.fire({
                                    title: 'Template editado com sucesso!',
                                    type: "success",
                                    toast: true,
                                    timer: 3000,
                                    showConfirmButton: false,
                                    position: 'top-end'
                                });

                                // await this.saveLocalFile(this.selectedTemplate.id)

                                this.getTemplates();
                                this.createNewTemplate();
                                this.loading = false
                            } else {
                                this.loading = false
                                Swal.fire({
                                    title: 'Erro ao editar template',
                                    html: data.error.error.error_user_msg ? data.error.error.error_user_msg : data.error.error.message,
                                    type: "error",
                                    showConfirmButton: true
                                });
                            }
                        })
                    }
                });
            },
            deleteTemplate(){
                Swal.fire({
                    title: 'Exclusão de template',
                    text: 'Tem certeza que deseja excluir este template? Esta ação não poderá ser desfeita, e o nome deste template não poderá ser utilizado novamente.',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Cancelar',
                    type: "warning",
                    showCloseButton: true
                }).then(result => {
                    if(result.value) {
                        this.loading = true
                        const template = {
                            template_id: this.selectedTemplate.id,
                            template_name: this.selectedTemplate.name
                        }
                        axios.post(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/delete_template/`, template).then(({data}) => {
                            if(!data.status || data.status !== 'error'){
                                Swal.fire({
                                    title: 'Template excluído com sucesso!',
                                    type: "success",
                                    toast: true,
                                    timer: 3000,
                                    showConfirmButton: false,
                                    position: 'top-end'
                                });
                                // this.deleteTemplateFile(this.selectedTemplate.id)
                                this.getTemplates();
                                this.createNewTemplate();
                                this.loading = false
                            } else {
                                this.loading = false
                                Swal.fire({
                                    title: 'Erro ao excluir template',
                                    html: data.error.error.error_user_msg ? data.error.error.error_user_msg : data.error.error.message,
                                    type: "error",
                                    showConfirmButton: true
                                });
                            }
                        })
                    }
                });
            },
            getTemplateInfo(templateId){
                this.rejectionReason = '';
                axios.get(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_template_info/`, {params: {template_id: templateId}}).then(({data}) => {
                    if(!data.status || data.status !== 'error'){
                        if(data.rejected_reason){
                            if(data.rejected_reason === 'ABUSIVE_CONTENT') this.rejectionReason = 'Conteúdo abusivo';
                            if(data.rejected_reason === 'INVALID_FORMAT') this.rejectionReason = 'Formato inválido';
                            if(data.rejected_reason === 'NONE') this.rejectionReason = 'Não informado';
                            if(data.rejected_reason === 'PROMOTIONAL') this.rejectionReason = 'Promocional';
                            if(data.rejected_reason === 'TAG_CONTENT_MISMATCH') this.rejectionReason = 'Categoria incorreta';
                            if(data.rejected_reason === 'SCAM') this.rejectionReason = 'Conteúdo suspeito';
                        }
                    }
                });
            },
            // async uploadHeaderFile(){
            //     if(!this.uploadedFile) return;
            //     return new Promise((resolve, reject) => {
            //         const reader = new FileReader();
            //         reader.readAsDataURL(this.uploadedFile);
            //         reader.onload = () => {
            //             const fileObj = {
            //                 file_size: this.uploadedFile.size,
            //                 file_type: this.uploadedFile.type,
            //                 file_name: this.uploadedFile.name,
            //                 file: reader.result
            //             }
                        
            //             axios.post(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/upload_resumable_file`,  fileObj).then(({data}) => {
            //                 if(!data.status || data.status !== 'error'){
            //                     this.uploadedFileId = data.h;
            //                     resolve(data.h);
            //                 } else {
            //                     resolve(null);
            //                 }
            //             });
            //         }
            //     });
            // },
            // async getHeaderMedia(){
            //     if(this.templateHeader.format === 'IMAGE' || this.templateHeader.format === 'VIDEO'){
            //         if(this.templateHeader.example?.header_handle?.length && !this.uploadedFile){
            //             const checkFile = await axios.get(`/api/checkFile`, {params: {fileName: this.selectedTemplate.id}}).then(({data}) => {
            //                 return data;
            //             })
            //             if(checkFile){
            //                 this.headerMedia = checkFile;
            //             }
            //         } else {
            //             if(this.uploadedFile){
            //                 this.headerMedia = this.createObjectURL(this.uploadedFile);
            //             }
            //         }
            //     }
            // },
            // getWppImage(url){
            //     axios({
            //         url: url,
            //         responseType: 'arraybuffer'
            //     }).then(response => {
            //         const blob = new Blob([response.data], { type: response.headers['content-type'] });
            //         const file = new File([blob], 'temp.jpg', { type: blob.type });

            //         this.uploadedFile = file;
            //         return file;
            //     });
            // },

        //    async saveLocalFile(id){
        //         const formData = new FormData();
        //         formData.append('file', this.uploadedFile);
        //         formData.append('file-name', id)

        //         await axios.post('/api/saveFile', formData, {
        //             headers: {
        //             'Content-Type': 'multipart/form-data'
        //             }
        //         }).then(async response => {
        //             await this.insertTemplateFile(id)
        //         }).catch(error => {
        //             console.error('Ocorreu um erro ao salvar o arquivo no servidor', error);
        //         })
        //     },

        //     async insertTemplateFile(id){
        //         if(!id || !this.uploadedFile || !this.uploadedFileId) return;

        //         const fileObj = {
        //             file_type: this.uploadedFile.type,
        //             file_id: this.uploadedFileId,
        //             template_id: id,
        //         }

        //         await axios.post('/api/insertTemplateFileInfo', fileObj).then(({data}) => {
        //             this.uploadedFile = null;
        //             this.uploadedFileId = '';
        //         }).catch(error => {
        //             console.error('Ocorreu um erro ao salvar o arquivo no banco de dados', error);
        //         })
        //     },

            // async deleteTemplateFile(id){
            //     if(!id) return;

            //     await axios.post('/api/deleteTemplateFileInfo', {template_id: id}).then(({data}) => {
            //         this.uploadedFile = null;
            //         this.uploadedFileId = '';
            //     }).catch(error => {
            //         console.error('Ocorreu um erro ao deletar o arquivo no banco de dados', error);
            //     })
            // }
        },
        watch: {
            allTemplates: function(){
                // console.log(this.allTemplates);
            },
            'variables': {
                handler: function (newVal, oldVal) {
                    if(newVal.length){
                        let newText = this.oldText;
                        newVal.map(el => {
                            if(el.id && el.text !== ''){
                                newText = newText.replace(el.id, el.text);
                                this.bodyText = newText;
                            }
                        });
                    }
                },
                deep: true
            },
            'templateHeader.format': {
                handler: function (newVal, oldVal) {
                    if(newVal === 'TEXT'){
                        this.templateHeader.media = '';
                        this.uploadedFile = null;
                    }
                    if(newVal === 'IMAGE' || newVal === 'VIDEO'){
                        this.templateHeader.text = '';
                    }
                    if(newVal === ''){
                        this.templateHeader.text = '';
                        this.templateHeader.media = '';
                        this.uploadedFile = null;
                    }
                },
                deep: true
            },
        }
    }
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.module-container {
    display: flex;
    gap: 20px;
    margin: 20px;
    max-height: 100%;
    max-width: 100%;
}

.selected {
    background-color: rgba(lightgray, 0.6) !important;
}

.templates-list {
    flex: 2;
    border: 1px solid lightgray;
    display: flex;
    border-radius: 7px;
    flex-wrap: wrap;
    flex-direction: column;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;
    gap: 5px;
    padding: 10px;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        padding: 10px;
        white-space: nowrap;
        gap: 10px;

        button {
            border-radius: 10px !important;
        }
    }

    &__item {
        padding: 20px;
        border: 1px solid lightgray;
        border-radius: 5px;
        background-color: rgba(lightgray, 0.3);
        cursor: pointer;
        transition: 0.3s;
        display: flex;
        flex-direction: column;
        box-shadow: 1px 1px 6px 0px lightgray;

        &:hover {
            background-color: rgba(lightgray, 0.5);
        }

        .item-name {
            font-size: 20px;
            font-weight: 600;
        }

        .item-category {
            font-size: 16px;
            font-weight: 500;
            color: gray;
        }
    }
}

.template-preview {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 2;
    border: 2px solid lightgray;
    border-radius: 7px;
    height: 85vh;
    max-height: 85vh;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;

    &__content {
        max-height: 100%;
        overflow-y: auto;
        padding: 10px;
    }

    &__id {
        font-size: 20px;
        font-weight: bold;
    }

    &__section {
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin: 15px 0;


        span {
            font-weight: bold;
        }

        label {
            color: gray;
            margin: 0;
        }

        .variables-container {
            margin: 10px 0;
            

            .variable-item {
                display: flex;
                gap: 10px;
                align-items: center;

                span {
                    font-size: large;
                }

                button {
                    border-radius: 10px !important;
                }
            }
        }

        .template-info {
            display: flex;
            gap: 20px;
            align-items: center;
        }

        .template-header {
            display: flex;
            gap: 20px;
            align-items: center;

            input {
                flex: 1;
            }

            select {
                flex: 2;
            }

            .custom-file-upload {
                flex: 1;
                text-align: center;
                border: 1px solid lightgray;
                padding: 5px;
                border-radius: 5px;
                cursor: pointer;
                transition: 0.3s ease-in-out;

                &:hover {
                    background-color: rgba(211, 211, 211, 0.5);
                }
            }

            .file-exist {
                background-color: rgb(214 233 248);
            }
        }
    }
}

.template-message-preview {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 7px;
    height: 85vh;
    max-height: 85vh;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;

    &__header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        padding: 10px;

        button {
            border-radius: 10px !important;
        }
    }

    .preview-slot {
        background-image: url('/images/background-wpp.png');
        background-color: #263b47;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .message-item {
            background-color: #037963;
            color: white;
            border-radius: 10px;
            margin: 10px;
            padding: 10px;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .message-header {
                font-size: 14px;
                font-weight: bold;
            }

            .message-body {
                font-size: 12px;
                font-weight: 500;

                .body-preview-text :deep(p) {
                    margin: 0 !important;
                }
            }

        }
    }
}
.action-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding: 10px;

    button {
        border-radius: 10px !important;
    }
}

.status {
    display: flex;
    gap: 5px;
    white-space: nowrap;
    font-weight: 600;
}


.approved {
    color: green;
}

.pending {
    color: orange;
}

.rejected {
    color: red;
}

.input-empty {
    border-color: red;
}

#loading-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -9999;

    .modal-dialog {
        background-color: white;
        padding: 20px;
        border-radius: 10px;
        max-width: unset;

        .modal-content {
            border: none;

            .modal-body {
                line-height: 3;
                display: flex;
                gap: 16px;
                align-items: center;

                span {
                    font-weight: bold;
                }
            }
        }
    }
}

.modal-showing {
   opacity: 1;
   z-index: 9999 !important;
}

</style>